import {
  SERVICE_INFORMATION_MANAGEMENT,
  VIEW_FREE_DELIVERIES_LOGIST,
  VIEW_RESERVED_DELIVERIES_LOGIST,
  VIEW_BOOKED_DELIVERIES_LOGIST,
  VIEW_AGREED_DELIVERIES_LOGIST,
  VIEW_REPORT_STATS_ORDER_DELIVERIES,
  VIEW_FREE_DELIVERIES_CARRIER,
  VIEW_BOOKED_DELIVERIES_CARRIER,
  VIEW_AGREED_DELIVERIES_CARRIER,
  VIEW_NEW_DELIVERIES_DRIVER,
  //COMPANY_DIRECTOR_PERMISSION,
  UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY, VIEW_LIST_UNLOADINGS,
  CREATE_UNLOADING, VIEW_REPORT_STATS_FOR_LOGISTS,
  CREATE_CROSS_DOCK
} from "../helpers/user_permission.helper";
import {BUYER, WAREHOUSE_WORKER} from "../helpers/user_role.helper";

export const configMenuLinks = {
    guest: [
      {
        links: ["/"],
        label: "Главная",
        homePage: true,
        langKey: "home",
      },
      {
        links: ["/deliveries/dashboard-deliveries"],
        label: "Доступные рейсы",
        homePage: false,
        langKey: "available",
      },
    ],
    auth: [
      {
        links: ["/settings"],
        label: "Настройки",
        homePage: true,
        accessTo: SERVICE_INFORMATION_MANAGEMENT,
        langKey: "settings",
      },
      {
        links: ["/start"],
        label: "Главная",
        homePage: true,
        accessTo: VIEW_FREE_DELIVERIES_CARRIER,
        langKey: "home",
      },
      // Рейсы для перевозчика (выпадающий список)
      {
        label: "Рейсы",
        homePage: false,
        accessTo: VIEW_FREE_DELIVERIES_CARRIER,
        langKey: "deliveries",
        isDropdown: true,
        subItems: [
          {
            links: ["/deliveries/list-new"],
            label: "В поиске",
            accessTo: VIEW_FREE_DELIVERIES_CARRIER,
            langKey: "searching",
          },
          {
            links: ["/deliveries/list-my"],
            label: "Мои рейсы",
            accessTo: VIEW_BOOKED_DELIVERIES_CARRIER,
            langKey: "myDeliveries",
          },
          {
            links: ["/deliveries/list-onload-carrier"],
            label: "На погрузке",
            accessTo: VIEW_BOOKED_DELIVERIES_CARRIER,
            langKey: "onLoad",
          },
          {
            links: ["/deliveries/list-enroute-carrier"],
            label: "В пути",
            accessTo: VIEW_BOOKED_DELIVERIES_CARRIER,
            langKey: "enRoute",
          },
          {
            links: ["/deliveries/list-archived-carrier"],
            label: "Архив",
            accessTo: VIEW_AGREED_DELIVERIES_CARRIER,
            langKey: "archive",
          },
        ]
      },
      // Главная для логиста
      {
        links: ["/start"],
        label: "Главная",
        homePage: true,
        accessTo: VIEW_FREE_DELIVERIES_LOGIST,
        langKey: "home",
      },
      // Рейсы для логиста (выпадающий список)
      {
        label: "Рейсы",
        homePage: false,
        accessTo: VIEW_FREE_DELIVERIES_LOGIST,
        langKey: "deliveries",
        isDropdown: true,
        subItems: [
          {
            links: ["/deliveries/list-free"],
            label: "В поиске",
            accessTo: VIEW_FREE_DELIVERIES_LOGIST,
            langKey: "searching",
          },
          {
            links: ["/deliveries/list-reserve"],
            label: "В резерве",
            accessTo: VIEW_RESERVED_DELIVERIES_LOGIST,
            langKey: "reserved",
          },
          {
            links: ["/deliveries/list-booked"],
            label: "На оформлении",
            accessTo: VIEW_BOOKED_DELIVERIES_LOGIST,
            langKey: "pending",
          },
          {
            links: ["/deliveries/list-onload-logist"],
            label: "На погрузке",
            accessTo: [VIEW_AGREED_DELIVERIES_LOGIST, UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY],
            langKey: "onLoad",
          },
          {
            links: ["/deliveries/list-enroute-logist"],
            label: "В пути",
            accessTo: VIEW_BOOKED_DELIVERIES_LOGIST,
            langKey: "enRoute",
          },
          {
            links: ["/deliveries/list-archived-logist"],
            label: "Архив",
            accessTo: VIEW_AGREED_DELIVERIES_LOGIST,
            langKey: "archive",
          },
        ]
      },
      // Кросс-докинг (выпадающий список)
      {
        label: "Кросс-докинг",
        homePage: false,
        accessTo: CREATE_CROSS_DOCK,
        langKey: "cross-dock",
        isDropdown: true,
        subItems: [
          {
            links: ["/cross-dock/list-active"],
            label: "Актуальные",
            accessTo: CREATE_CROSS_DOCK,
            langKey: "crossDockActual",
          },
          {
            links: ["/cross-dock/list-archive"],
            label: "Архив",
            accessTo: CREATE_CROSS_DOCK,
            langKey: "crossDockArchive",
          },
        ]
      },
      {
        links: ["/reports/stats-orders-delivery", "/reports/stats-cargo", "/reports/stats-refused-deliveries"],
        label: "Отчеты",
        homePage: false,
        accessTo: VIEW_REPORT_STATS_ORDER_DELIVERIES,
        langKey: "reports",
      },
      {
        links: ["/reports/stats-cargo-times"],
        label: "Отчеты",
        homePage: false,
        accessTo: [VIEW_REPORT_STATS_FOR_LOGISTS],
        langKey: "reports",
      },
      {
        links: ["/deliveries/list-new-driver"],
        label: "Новые рейсы",
        homePage: false,
        accessTo: VIEW_NEW_DELIVERIES_DRIVER,
        langKey: "newDeliveries",
      },
    ],
    [WAREHOUSE_WORKER]: [
      {
        links: ["/loading-unloading"],
        label: "Погрузка - Разгрузка",
        homePage: true,
        accessTo: UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY,
        langKey: "loadingUnloading",
      },
      {
        links: ["/deliveries/list-free"],
        label: "В поиске",
        homePage: false,
        accessTo: VIEW_FREE_DELIVERIES_LOGIST,
        langKey: "searching",
      },
    ],
  [BUYER]: [
    {
      links: ["/unloadings/list-actual"],
      label: "Разгрузки",
      homePage: true,
      accessTo: VIEW_LIST_UNLOADINGS,
      langKey: "unloadingsActual",
    },
    {
      links: ["/unloadings/list-archived"],
      label: "Архив разгрузок",
      homePage: false,
      accessTo: CREATE_UNLOADING,
      langKey: "unloadingsArchived",
    }
  ]
};